module.exports = __webpack_public_path__ + "img/IMG_3758.4dca3b84.jpg";